(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/inject-selfservice-callback.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/inject-selfservice-callback.js');
"use strict";



const {
  useParams
} = ReactRouterDOM;
const {
  useSelector
} = ReactRedux;
const {
  useEffect
} = React;
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const InjectSelfserviceCallback = () => {
  const params = useParams();
  const paramDrawNumber = Number(params.drawNumber);
  const selectedCoupon = useSelector(state => state.coupons.find(_ref => {
    let {
      drawNumber
    } = _ref;
    return drawNumber === paramDrawNumber;
  }));
  useEffect(() => {
    if (isSelfService) {
      svs.components.selfserviceCart.getCartInstance().setGameCallback(() => {
        if (selectedCoupon) {
          if (selectedCoupon.isPayable) {
            return svs.components.selfserviceCart.constants.GAMECALLBACK_HASCOMPLETEGAME;
          }
          for (const event of selectedCoupon.drawEvents) {
            if (event.includes(true)) {
              return svs.components.selfserviceCart.constants.GAMECALLBACK_HASINCOMPLETEGAME;
            }
          }
        }
        return svs.components.selfserviceCart.constants.GAMECALLBACK_NOGAME;
      });
    }
  }, [selectedCoupon]);
  return null;
};
svs.challenge.InjectSelfserviceCallback = InjectSelfserviceCallback;

 })(window);